import { LaskunLiitetiedosto } from '../../model/lasku'

export class LaskuUriService {
  getPdfUri(asiakasId: string | number, laskuId: string): string {
    return 'laskut/' + asiakasId + '/' + laskuId + '.pdf'
  }

  getTyojonoLaskuTulostusUri(asiakasId: string | number, tyojonoId: string): string {
    return '/tyojono/' + asiakasId + '/lasku_tulostus/' + tyojonoId
  }

  getTyojonoLaskuGeneroiPdfUudelleenUri(asiakasId: string | number, tyojonoId: string): string {
    return '/tyojono/' + asiakasId + '/lasku_tee_pdf_uudelleen/' + tyojonoId
  }

  getTyojonoLaskuMyyntilaskuOstolaskuksi(myyjanAsiakasAvain: string, tyojonoAvain): string {
    return '/tyojono/' + myyjanAsiakasAvain + '/myyntilasku-ostolaskuksi/' + tyojonoAvain
  }

  getTyojonoLaskuEmailUri(asiakasId: string | number, tyojonoId: string): string {
    return '/tyojono/' + asiakasId + '/lasku_email/' + tyojonoId
  }

  getTyojonoPerintaLaskuEmailUri(asiakasId: string | number, tyojonoId: string): string {
    return '/tyojono/' + asiakasId + '/lasku_perintaan/' + tyojonoId
  }

  getTyojonoPerintaLaskunPeruutusEmailUri(asiakasId: string | number, tyojonoId: string): string {
    return '/tyojono/' + asiakasId + '/lasku_perinta_peruutettu/' + tyojonoId
  }

  getTyojonoTiedotaPerinnassaOlevanLaskunMuutoksestaTarvittaessaUri(asiakasId: string | number, tyojonoId: string): string {
    return '/tyojono/' + asiakasId + '/tiedota_perinnassa_olevan_laskun_muutoksesta_tarvittaessa/' + tyojonoId
  }

  getTyojonoLaskuTasapainoitaJaLahetaUri(asiakasId: string | number, tyojonoId: string): string {
    return '/tyojono/' + asiakasId + '/lasku_tasapainoita_ja_laheta/' + tyojonoId
  }

  getTyojonoLaskuSahkoinenlUri(asiakasId: string | number, tyojonoId: string): string {
    return '/tyojono/' + asiakasId + '/lasku_sahkoinen/' + tyojonoId
  }

  getTyojonoLaskuVientiLemonatoriinUri(asiakasId: string | number, tyojonoId: string): string {
    return '/tyojono/' + asiakasId + '/lasku_lemonaattoriin/' + tyojonoId
  }

  getTyojonoLaskuVientiLemonatoriinDataUri(asiakasId: string | number, tyojonoId: string): string {
    return '/tyojono-data/' + asiakasId + '/lasku_lemonaattoriin/' + tyojonoId
  }

  getTyojonoLaskuSqlVientiLemonatoriinMassaAsiakasFanoutUri(asiakasId: string | number, tyojonoId: string): string {
    return '/tyojono/' + asiakasId + '/lasku_lemonaattoriin_massa_asiakas_fanout/' + tyojonoId
  }
  getTyojonoLaskuPostgresUri(asiakasAvain: string | number, tyojonoId: string): string {
    return '/tyojono/' + asiakasAvain + '/lasku_to_postgres/' + tyojonoId
  }

  getLaskuTilatAsiakkaanEraantyneetUri(asiakasId: string | number, tyojonoId: string): string {
    return '/tyojono/' + asiakasId + '/lasku_tilat_eraantyneet/' + tyojonoId
  }

  getLaskuEraantyneetSmsUri(asiakasId: string | number, tyojonoId: string): string {
    return '/tyojono/' + asiakasId + '/lasku_eraantynyt_sms/' + tyojonoId
  }

  getLaskuasetuksetUri(asiakasAvain: string, asetusAvain: string): string {
    return '/customers/' + asiakasAvain + '/customer-invoices-settings/' + asetusAvain
  }

  getToistuvatLaskutCollectionUri(asiakasAvain: string): string {
    return 'customers/' + asiakasAvain + '/customer-laskut-toistuvat'
  }

  getToistuvanLaskunUri(asiakasAvain: string, laskuAvain: string): string {
    return 'customers/' + asiakasAvain + '/customer-laskut-toistuvat/' + laskuAvain
  }

  getToistuvanLaskunHistoriaUri(asiakasAvain: string, laskuAvain: string): string {
    return 'customers/' + asiakasAvain + '/customer-laskut-toistuvat/' + laskuAvain + '/historia'
  }

  getToistuvanLaskunHistoriaAvaimellaUri(asiakasAvain: string, laskuAvain: string, historiaAvain: string): string {
    return 'customers/' + asiakasAvain + '/customer-laskut-toistuvat/' + laskuAvain + '/historia/' + historiaAvain
  }

  getToistuvanLaskunToistoasetuksetUri(asiakasAvain: string, laskuAvain: string): string {
    return 'customers/' + asiakasAvain + '/customer-laskut-toistuvat/' + laskuAvain + '/toistoasetukset'
  }

  getTypeaheadAsiakasDokumentinUriNew(asiakasAvain: string): string {
    return 'customers/' + asiakasAvain + '/customer-laskut-typeahead-asiakas/' + asiakasAvain + '_laskut_typeahead_asiakas'
  }

  getTypeaheadTuoteDokumentinUriNew(asiakasAvain: string): string {
    return 'customers/' + asiakasAvain + '/customer-laskut-typeahead-tuote/' + asiakasAvain + '_laskut_typeahead_tuote'
  }

  getTypeaheadToimittajaDokumentinUriNew(asiakasAvain: string): string {
    return 'customers/' + asiakasAvain + '/customer-laskut-typeahead-toimittaja/' + asiakasAvain + '_laskut_typeahead_toimittaja'
  }

  getToistuvanLaskunTyojonoUri(asiakasAvain: string, tyojonoAvain: string): string {
    return 'tyojono/' + asiakasAvain + '/toistuvat_laskut/' + tyojonoAvain
  }

  getLaskuAsiakkaatCollectionUri(asiakasAvain: string): string {
    return `customers/${asiakasAvain}/lasku-asiakkaat`
  }

  getLaskuAsiakasUri(asiakasAvain: string, laskunAsiakkaanAvain: string): string {
    return `${this.getLaskuAsiakkaatCollectionUri(asiakasAvain)}/${laskunAsiakkaanAvain}`
  }

  getLaskuTuotteetCollectionUri(asiakasAvain: string): string {
    return `customers/${asiakasAvain}/lasku-tuotteet`
  }

  getLaskuTuoteUri(asiakasAvain: string, tuoteAvain: string): string {
    return `${this.getLaskuTuotteetCollectionUri(asiakasAvain)}/${tuoteAvain}`
  }

  getLaskuToimittajatCollectionUri(asiakasAvain: string): string {
    return `customers/${asiakasAvain}/lasku-toimittajat`
  }

  getLaskuToimittajaUri(asiakasAvain: string, toimittajaAvain: string): string {
    return `${this.getLaskuToimittajatCollectionUri(asiakasAvain)}/${toimittajaAvain}`
  }

  getToimittajaReplikointiTyojonoCollectionUri(asiakasId: string): string {
    return '/tyojono/' + asiakasId + '/replikoi-toimittaja/'
  }

  getToimittajaReplikointiTyojonoUri(asiakasId: string, tyojonoAvain: string): string {
    return this.getToimittajaReplikointiTyojonoCollectionUri(asiakasId) + tyojonoAvain
  }

  annaLiitetiedostonCloudStorageUri(asiakasAvain: string, liitetiedosto: LaskunLiitetiedosto): string {
    return 'laskut/' + asiakasAvain + '/liitetiedostot/' + liitetiedosto.avain
  }

  getTyojonoPurkuViestitEmailUri(asiakasAvain: string, tyojonoId: string): string {
    return '/tyojono/' + asiakasAvain + '/purku_emailit/' + tyojonoId
  }

  getTilastojenPaivitysTyojonoUri(asiakasAvain: string, tyojonoId: string): string {
    return 'tyojono/' + asiakasAvain + '/tilastojen-paivitys/' + tyojonoId
  }

  getPostgresReplicationTyojonoUri(asiakasId: string, tyojonoId: string): string {
    return '/tyojono/' + asiakasId + '/vie-lasku-postgresiin/' + tyojonoId
  }

  teeLaskunEmailTag(laskuUri: string, asikasAvain: string, asiakasId: string, kasiteltavanAvain: string): string {
    return 'lasku2_____' + laskuUri + '_____' + kasiteltavanAvain + '_____' + asikasAvain + '_____' + asiakasId
  }

  puraLaskunEmailTag(tag: string): { laskuUri: string; laskuAvain: string; kasiteltavanAvain: string; asiakasId: string; asiakasAvain: string } {
    if (tag.startsWith('lasku1_____')) {
      const split = tag.replace('lasku1_____', '').split('_____')
      const laskuUri = split[0]
      const asiakasId = tag.replace('lasku1_____/laskut/', '').replace(/\/laskut\/.+/, '')
      const laskuAvain = laskuUri.replace('/laskut/' + asiakasId + '/laskut/', '')
      return {
        laskuUri: laskuUri,
        asiakasId: asiakasId,
        kasiteltavanAvain: split[1],
        laskuAvain: laskuAvain,
        asiakasAvain: null,
      }
    } else if (tag.startsWith('lasku2_____')) {
      const split = tag.replace('lasku2_____', '').split('_____')
      const laskuUri = split[0]
      // Vanhoissa tageissa uri on muotoa /laskut/{asiakasId}/laskut/{laskuAvain}, uusissa customers/{asiakasAvain}/laskut/{laskuAvain}
      const laskuAvain = laskuUri.split('/').pop()
      return {
        laskuUri: laskuUri,
        asiakasId: split[3],
        kasiteltavanAvain: split[1],
        laskuAvain: laskuAvain,
        asiakasAvain: split[2],
      }
    }
    throw new Error('Laskutagia ei osata purkaa ' + tag)
  }

  getJatkuvienLaskujenLahetystiedotCollectionUri(laskuttavanAsiakkaanAvain: string): string {
    return `customers/${laskuttavanAsiakkaanAvain}/jatkuvien_laskujen_lahetystiedot`
  }

  getJatkuvanLaskunLahetystietoUri(laskuttavanAsiakkaanAvain: string, avain: string): string {
    return `${this.getJatkuvienLaskujenLahetystiedotCollectionUri(laskuttavanAsiakkaanAvain)}/${avain}`
  }

  getLaskuLahetystiedotCollectionUri(asiakasAvain: string): string {
    return `customers/${asiakasAvain}/lasku-lahetystiedot`
  }

  getLaskuLahetystietoUri(asiakasAvain: string, kasiteltavanAvain: string): string {
    return `${this.getLaskuLahetystiedotCollectionUri(asiakasAvain)}/${kasiteltavanAvain}`
  }

  getCustomerLaskutCollectionUri(asiakasAvain: string): string {
    return `customers/${asiakasAvain}/laskut`
  }

  getCustomerLaskuUri(asiakasAvain: string, laskuAvain: string): string {
    return `${this.getCustomerLaskutCollectionUri(asiakasAvain)}/${laskuAvain}`
  }

  getCustomerLaskunAlikokoelmaCollectionUri(asiakasAvain: string, laskuAvain: string, alikokoelma: string): string {
    return `${this.getCustomerLaskuUri(asiakasAvain, laskuAvain)}/${alikokoelma}`
  }

  getCustomerLaskunAlikokoelmanDokumenttiUri(asiakasAvain: string, laskuAvain: string, alikokoelma: string, dokumenttiAvain: string): string {
    return `${this.getCustomerLaskunAlikokoelmaCollectionUri(asiakasAvain, laskuAvain, alikokoelma)}/${dokumenttiAvain}`
  }

  getCustomerLaskunToistoasetuksetCollectionUri(asiakasAvain: string, laskuAvain: string): string {
    return this.getCustomerLaskunAlikokoelmaCollectionUri(asiakasAvain, laskuAvain, 'toistoasetukset')
  }

  getCustomerLaskunToistoasetusUri(asiakasAvain: string, laskuAvain: string, asetusAvain: string): string {
    return this.getCustomerLaskunAlikokoelmanDokumenttiUri(asiakasAvain, laskuAvain, 'toistoasetukset', asetusAvain)
  }

  getCustomerLaskunToimintalokiCollectionUri(asiakasAvain: string, laskuAvain: string): string {
    return this.getCustomerLaskunAlikokoelmaCollectionUri(asiakasAvain, laskuAvain, 'toimintaloki')
  }

  getCustomerLaskunToimintalokiUri(asiakasAvain: string, laskuAvain: string, lokiAvain: string): string {
    return this.getCustomerLaskunAlikokoelmanDokumenttiUri(asiakasAvain, laskuAvain, 'toimintaloki', lokiAvain)
  }

  getCustomerLaskunHistoriaUri(asiakasAvain: string, laskuAvain: string, historiaAvain: string): string {
    return this.getCustomerLaskunAlikokoelmanDokumenttiUri(asiakasAvain, laskuAvain, 'historia', historiaAvain)
  }

  getCustomerLaskunReskontraCollectionUri(asiakasAvain: string, laskuAvain: string): string {
    return this.getCustomerLaskunAlikokoelmaCollectionUri(asiakasAvain, laskuAvain, 'lasku-reskontra')
  }

  getCustomerLaskunReskontraUri(asiakasAvain: string, laskuAvain: string, reskontraAvain: string): string {
    return this.getCustomerLaskunAlikokoelmanDokumenttiUri(asiakasAvain, laskuAvain, 'lasku-reskontra', reskontraAvain)
  }
}
